<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Info Institucional" pageTitle="Info Institucional" />
            <InstitutionalContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import InstitutionalContent from '../Institutional/InstitutionalContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'InstitutionalPage',
    components: { MainHeader, PageTitle, InstitutionalContent, FooterArea },
    mounted() { document.body.classList.add('body-bg-f8faff'); },
};
</script>
